import { RentDetailedJSON } from './RentDetailed';
import { RentStandardJSON } from './RentStandard';
import { RentTwoTenantsJSON } from './RentTwoTenants';
import { SaleStandardJSON } from './SaleStandard';

export {
  RentStandardJSON,
  RentDetailedJSON,
  RentTwoTenantsJSON,
  SaleStandardJSON,
};
